import { StyleSheet } from 'react-native';

import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

export default StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: Layout.statusBar,
        backgroundColor: Colors.white
    },
    loading: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1
    },
    headerBar: {
        paddingTop: Layout.gutterSmall,
        paddingBottom: Layout.gutterSmall,
        zIndex: 9999
    },

    pageHeader: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

    pageTitle: {
        fontSize: 22
    },

    headerList: {
        marginTop: 16,
        padding: 16,
        fontSize: 16,
        color: Colors.dark
    },

    content: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'flex-start'
    },

    listContent: {
        paddingLeft: Layout.gutterMedium,
        paddingTop: Layout.gutterMedium
    },

    selectedItem: {
        backgroundColor: Colors.lightBlue
    },

    prodDisponivel: {
        opacity: 1
    },
    prodIndisponivel: {
        opacity: 0.8,
        backgroundColor: Colors.lighter
    },

    listItem: {
        minHeight: 'auto',
        flexBasis: 0,
        alignItems: 'center',
        padding: Layout.gutterMedium,
        marginRight: Layout.gutterMedium,
        marginBottom: Layout.gutterMedium
    },
    productBorder: {
        borderWidth: 1,
        borderColor: Colors.border
    },
    notProduct: {
        cursor: 'auto'
    },
    itemWrap: {
        maxWidth: '100%',
        alignItems: 'center',
        flex: 1,
        display: 'flex',
        width: '100%'
    },
    itemMaxWidth: {
        maxWidth: '100%',
        width: '100%',
        flex: 1
    },
    image: {
        width: 80,
        height: 80,
        margin: Layout.gutter
    },
    imageIndisp: {
        width: 80,
        height: 80,
        margin: Layout.gutter,
        opacity: 0.2
    },
    lineContent: {
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    marginBottom: {
        marginBottom: Layout.gutter
    },
    itemName: {
        flex: 1
    },
    itemInfo: {
        color: Colors.dark
    },
    itemValue: {
        color: Colors.secondary,
        fontSize: 16
    },
    emptyState: {
        flex: 1,
        padding: Layout.gutter,
        justifyContent: 'center',
        alignItems: 'center'
    },
    emptyStateText: {
        textAlign: 'center'
    },

    flexRow: {
        flexDirection: 'row'
    },

    actionsContainer: {
        flex: 2,
        alignItems: 'center',
        flexDirection: 'row'
    },

    actionButton: {
        backgroundColor: Colors.lighter,
        marginRight: Layout.gutter,
        padding: Layout.gutterMedium,
        borderRadius: 100
    },

    radioButtonContainer: {
        flex: 1,
        marginVertical: 14
    },
    radioButtonIcon: {
        alignItems: 'flex-start'
    },
    radioButtonLabel: {
        alignItems: 'flex-start',
        fontSize: 16,
        marginLeft: 20
    },

    buttonFiltro: {
        marginRight: Layout.gutterMedium
    },
    buttonContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    buttonCadastro: {
        marginTop: 0,
        marginRight: Layout.gutterMedium
    },
    addProdutoButton: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    }
});
